/**
 * Email Events Listing Page
 * Shows all system email execution events
 */

import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getEmailEvents } from "../redux/emailEventSlice";
import EmailEventTable from "../components/email/EmailEventTable";
import ServerPagination from "../components/ServerPagination";
import PageSizeSelector from "../components/PageSizeSelector";


const EmailEvents = () => {
  const dispatch = useDispatch();
  const { events, loading, pagination } = useSelector((state) => state.emailEvents);

  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  useEffect(() => {
    dispatch(getEmailEvents(
  {page: currentPage,
      page_size: pageSize,}
    ));
  }, [dispatch, currentPage, pageSize]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handlePageSizeChange = (e) => {
    setPageSize(Number(e.target.value));
    setCurrentPage(1);
  };

 return (
  <div className="p-6">
    <div className="bg-white rounded-xl shadow-md p-6">
      <h1 className="text-2xl font-semibold mb-6">
        Email Campaign Logs
      </h1>
       <PageSizeSelector
          pageSize={pageSize}
          onPageSizeChange={handlePageSizeChange}
        />

      {loading ? (
        <div className="text-center py-12 text-gray-500">
          Loading email events...
        </div>
      ) : (
        <>
        <EmailEventTable events={events || []} />

        { pagination && pagination.totalPages > 1 && (
          <ServerPagination
            currentPage={pagination.currentPage}
            totalPages={pagination.totalPages}
            onPageChange={handlePageChange}
            totalCount={pagination.count}
            pageSize={pagination.pageSize}
          />
        )}
        </>
      )}

    </div>
  </div>
);
};

export default EmailEvents;